import moment from 'moment';

export const displayDate = (date: Date, format: string) => {
  return moment(date).format(format);
};

export const getDefaultInputDate = () => {
  return moment().format('yyyy-MM-DD');
};
